import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { ExtractedStructuredTextHeading } from 'utils/structured-text.utils';

import Link from 'components/@common/Link';

interface Props {
  headings: Array<ExtractedStructuredTextHeading>;
}

const CustomPageTextIndexBlock = ({ headings = [] }: Props) => {
  if (headings?.length === 0) return null;

  return (
    <>
      <Typography
        sx={{
          mb: { xs: 2, md: 3 },
        }}
      >
        <FormattedMessage id="index" />
      </Typography>
      <Stack
        component="ul"
        sx={{
          listStyle: 'none',
          p: 0,
          m: 0,
          '& > *:not(last-of-type)': {
            mb: { xs: 2, md: 3 },
          },
        }}
      >
        {headings.map((heading, index) => (
          <li key={`${index}${heading.id}`}>
            <Link
              color="text.primary"
              underline="always"
              href={`#${heading.id}`}
              variant="overline"
            >
              {heading.text}
            </Link>
          </li>
        ))}
      </Stack>
    </>
  );
};

export default CustomPageTextIndexBlock;
